import React from "react";
import { Button, Typography } from "antd";
import { InboxOutlined, SearchOutlined } from "@ant-design/icons";
import styles from "./styles.module.css";

/* Shared empty state for list screens. An empty table used to render as a bare
 * strip with no way forward — this gives every list the same "here's what this
 * is, here's how to add one" shape the projects grid already had.
 *
 * `filtered` swaps the copy: when the list is empty because of a search or a
 * filter, offering "create" is the wrong advice, so the action is dropped. */
const EmptyState = ({
  icon,
  title,
  description,
  actionLabel,
  actionIcon,
  onAction,
  actionHref,
  filtered = false,
  filteredTitle = "نتیجه‌ای پیدا نشد",
  filteredDescription = "فیلترها یا عبارت جست‌وجو رو عوض کن و دوباره امتحان کن.",
  compact = false,
}) => {
  const showAction = !filtered && actionLabel && (onAction || actionHref);

  return (
    <div className={`${styles.wrap} ${compact ? styles.compact : ""}`}>
      <div className={styles.iconWrap}>
        {filtered ? <SearchOutlined /> : icon || <InboxOutlined />}
      </div>

      <Typography.Title level={5} className={styles.title}>
        {filtered ? filteredTitle : title}
      </Typography.Title>

      <Typography.Text type="secondary" className={styles.description}>
        {filtered ? filteredDescription : description}
      </Typography.Text>

      {showAction && (
        <Button
          type="primary"
          size={compact ? "middle" : "large"}
          icon={actionIcon}
          href={actionHref}
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
